import { AlertBannerVariant } from "./types";

export const DEFAULT_BG: Record<AlertBannerVariant, string> = {
  warning: "#E215151A",
  info: "#1565C01A",
};

export const DEFAULT_COLOR: Record<AlertBannerVariant, string> = {
  warning: "#000302",
  info: "#1565C0",
};

export const VARIANT_STYLES: Record<
  AlertBannerVariant,
  {
    paddingInlineStart: string;
    iconColor: string;
    titleColor: string;
    messageTag: "li" | "p";
    iconRotate?: string;
  }
> = {
  warning: {
    paddingInlineStart: "55px",
    iconColor: "#E21515",
    titleColor: "inherit",
    messageTag: "li",
  },
  info: {
    paddingInlineStart: "40px",
    iconColor: DEFAULT_COLOR.info,
    titleColor: "inherit",
    messageTag: "p",
    iconRotate: "rotate(180deg)",
  },
};
